import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Nav, NavItem, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalBody } from 'reactstrap';
import { useGetProfile, useUploadProfileImg } from "../../views/Myprofile/api";
import * as yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { X } from "lucide-react";
import { Avatar, CircularProgress } from '@mui/material';
import { stringAvatar } from "../../lib/avatar";
import LanguageContext from "../../views/languageContext/LanguageContext";
import { useTranslation } from "react-i18next";
import { useLogOut } from "../../views/Login/api";

import {
    useConnect,
    useAccount,
    useSwitchNetwork,
    useDisconnect,
} from "wagmi";
import { chainId } from '../../views/web3/chain';

import toast from "react-hot-toast";

const InnerHeader = (props) => {


    const { t } = useTranslation();
    const schema = yup.object().shape({
        profile: yup.mixed()
            .test("required", t('Profile image is required'), file => !!file)
            .required(t("Profile image is required")),
    })

    const { handleSubmit, formState: { errors }, setError, clearErrors, setValue } = useForm({
        resolver: yupResolver(schema),
        mode: 'onChange',
    });

    const { language, changeLanguage } = useContext(LanguageContext)

    const languageImages = {
        english: require('../../assets/images/us.svg').default,
        // french: require('../../assets/images/egypt.svg').default,
        // Portuguese: require('../../assets/images/afghanistan.svg').default,
         french: require('../../assets/images/french.svg').default,
         Portuguese: require('../../assets/images/portuguese.svg').default,
    };

    const [profileImg, setProfileImg] = useState("")
    const updateProfileImage = useUploadProfileImg();

    const readFileAsync1 = (file) => {
        return new Promise(
            (resolve, reject) => {
                if (!file) return

                const reader1 = new FileReader()
                reader1.onload = () => {
                    resolve(reader1.result)
                }
                reader1.onerror = reject
                reader1.readAsDataURL(
                    file
                )
            }
        )
    }

    const handleProfileImg = (event) => {
        let img = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const imgCheck = new Image();
            imgCheck.src = event.target.result;
            imgCheck.onload = async () => {
                if (imgCheck.width >= 100 && imgCheck.height >= 100) {

                    if (img.size < 2 * 1024 * 1024) {
                        const newImage1 = await readFileAsync1(img)
                        setProfileImg(newImage1);
                        setValue("profile", img)
                    } else {
                        setError("profile", { message: t("Image Size Must be Less than 2MB.") });
                    }
                }
                else {
                    setError("profile", { message: t("Image Dimensions should be 100 x 100 Pixels.") });
                }
            };

            imgCheck.onerror = (error) => {
            };
        }
        reader.onerror = (error) => {
        };
        reader.readAsDataURL(img);
    }

    const [isedit, setIsedit] = useState(false)
    const toggleEdit = () => {
        setIsedit(!isedit)
    }


    const active = false;


    const [scroll, setScroll] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 50);
        });
    }, []);

    const navigate = useNavigate();
    // Function to handle click events on menu items
    const { data: getProfile } = useGetProfile()

    const userLogout = useLogOut()
    const logout = async () => {
        const res = await userLogout.mutateAsync({ email: getProfile?.data?.email })
        if (res?.status) {
            sessionStorage.removeItem("user_JWT")
            navigate('/')
        }

    }
    const onSubmit = async (data) => {

        let formData = new FormData()
        formData.append("id", getProfile?.data?._id)
        formData.append("profile", data.profile)
        await updateProfileImage.mutateAsync(formData)

    }


    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenus = () => {
        setIsMenuOpen(!isMenuOpen);
    };


    useEffect(() => {
        if (isMenuOpen) {
            document.body.classList.add('menuopen');
        } else {
            document.body.classList.remove('menuopen');
        }
    }, [isMenuOpen]);

    useEffect(() => {
        const languageClasses = {
            english: 'english',
            french: 'french',
            Portuguese: 'Portuguese',
        };

        document.body.className = '';

        if (languageClasses[language]) {
            document.body.classList.add(languageClasses[language]);
        }

        return () => {
            document.body.className = '';
        };
    }, [language]);

    const { connectAsync, connectors } = useConnect();
    const { disconnectAsync } = useDisconnect();


    const { address, isConnected } = useAccount();
    const { switchNetworkAsync } = useSwitchNetwork({
        chainId: chainId.BNB,
        throwForSwitchChainNotSupported: true,
    });







    const onConnectWalletClick = async () => {
     
        if (isConnected) {
            

            return;
        }

        try {
          
            const connectedAccount = await connectAsync({ connector: connectors[0] });


            if (connectedAccount.chain.id !== chainId.BNB) {
                await switchNetworkAsync();
            }

            if (getProfile?.data?.walletAddress.toLowerCase() !== connectedAccount.account.toLowerCase()) {
                await disconnectAsync();
                return toast.error(t("Connect User address"));
            }
            // toggleCnWal()
            toast.success(t(" Wallet connected successfully"));

            localStorage.setItem("account", connectedAccount.account);

        } catch (error) {
        } 
    };




    const disconnectaccount = async () => {
        try {
          await disconnectAsync();
          toast.success('Disconnected successfully!');
        } catch (error) {
          toast.error('Failed to disconnect: ' + error.message);
        }
      };

    return (
        <header id="homeheader" className={scroll ? "indHd hdrFd indHdInr scroll" : "indHd hdrFd indHdInr"}>
            <nav className={active ? "navbar navbar-expand-xl fixed-top sbMenu" : "navbar navbar-expand-xl fixed-top"} style={{ background: '#1E4A26' }}>
                <div className="container-fluid NavCntrBrd">
                    <div className="d-flex align-items-center">
                        <a className="navbar-brand NvrBrd" href="/"><img src={require('../../assets/images/logo.png')} alt="logo" /></a>
                        <button className="TglBtn EpySty d-block d-xl-none" onClick={toggleMenus}><img src={require('../../assets/images/toggle.png')} alt="" /></button>
                    </div>
                    <div className="hdNavenu">
                        <Nav navbar className="align-items-center ml-auto flex-row">

                            <NavItem>
                                <UncontrolledDropdown className="PrflDD  my-2">
                                    <DropdownToggle>
                                        {!getProfile?.data?.profile ? getProfile && <div className="PrflDflIg"><span ><Avatar {...stringAvatar(getProfile?.data?.userName)} /></span></div>

                                            :
                                            <img src={getProfile?.data?.profile} alt="" className="pro-dp" />
                                        }
                                        <span className="mx-2">{getProfile?.data?.userName}</span>
                                        <img src={require('../../assets/images/down-arrow-white.png')} alt="" className="ArwDwn" />
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-menu-right">
                                        <DropdownItem>
                                            <div className="DDItmDv">
                                                {!getProfile?.data?.profile ? getProfile && <Avatar {...stringAvatar(getProfile?.data?.userName)} />
                                                    :
                                                    <img src={getProfile?.data?.profile} alt="" className="pro-dp2" />
                                                }
                                                <div className="ml-2">
                                                    <h3>{getProfile?.data?.userName}</h3>
                                                    <h4 className="p-email">{getProfile?.data?.email}</h4>
                                                </div>
                                            </div>
                                            <div className="DDdivider"></div>
                                            <div className="DDItmDv">
                                                <img src={require('../../assets/images/kkogcoin.png')} alt="" />
                                                <div className="ml-2">
                                                    <h5>{t('Coin Balance')}</h5>
                                                    <h6>{parseFloat(getProfile?.balance?.currencyBalance).toFixed(2)} <span>KKOG</span></h6>
                                                </div>
                                            </div>
                                        </DropdownItem>
                                        <DropdownItem onClick={() => navigate('/myprofile')}><img src={require('../../assets/images/profile-circle.png')} alt="" className="mr-2" />{t('My Profile')}</DropdownItem>
                                        <DropdownItem onClick={() => navigate('/activity')}><img src={require('../../assets/images/eye.png')} alt="" className="mr-2" />{t('Activity')}</DropdownItem>

                                 

                                        <DropdownItem className="d-flex align-items-center justify-content-between"><img src={require('../../assets/images/wallet-money.svg').default} alt="" />

                                      
                                            {isConnected && getProfile?.data?.walletAddress ?
                                                //  <a href="/" className="mx-2" style={{color:"#151515"}} >{address}</a>
                                                <>
                                                    <a href="/" className="mx-2 " style={{ color: "#151515" }}>
                                                        {address.slice(0, 6) + '......' + address.slice(-4)}
                                                    </a>
                                                    <button
                                                        type="button"
                                                        // className="InputIcon EpySty eyeslsIg text-danger"
                                                        style={{ all: 'unset', fontSize: '13px', fontWeight: '400', lineHeight: '18px', color: '#FF484E', cursor:"pointer" }}
                                                        onClick={disconnectaccount}
                                                    >
                                                        Disconnect

                                                    </button>
                                                </>
                                                // <span >
                                                //     <button
                                                //         type="button"
                                                //         className="InputIcon EpySty eyeslsIg text-success"

                                                //     >
                                                //         {t('Connected')}

                                                //     </button>
                                                // </span>
                                                :
                                                getProfile?.data?.walletAddress && <span >
                                                    <button
                                                        type="button"
                                                        // className="InputIcon EpySty eyeslsIg text-danger"
                                                        style={{ all: 'unset', fontSize: '13px', fontWeight: '400', lineHeight: '18px', color: '#151515' }}
                                                        onClick={() => onConnectWalletClick()}
                                                    >
                                                        {t('Connect Wallet')}

                                                    </button>
                                                    {/* < href="/" style={{fontSize: '13px', fontWeight: '400', lineHeight: '18px', color:'#FF484E'}}>Disconnect</a> */}
                                                </span>
                                            }

                                        </DropdownItem>


                                        <DropdownItem onClick={logout} ><img src={require('../../assets/images/logout.svg').default} alt="" className="mr-2" />{t('Logout')}</DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </NavItem>
                            <NavItem>
                                <UncontrolledDropdown className="HdrCntryDD  my-2">
                                    <DropdownToggle className="HdrCntryDDBg">
                                        <img src={languageImages[language]} alt="" />
                                        <img src={require('../../assets/images/down-arrow-white.png')} alt="" className="ArwDwn" />
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-menu-right">
                                        <DropdownItem onClick={() => changeLanguage('english')} disabled={language === 'english'}
                                            >
                                                <img src={require('../../assets/images/us.svg').default} alt="" /></DropdownItem>
                                        <DropdownItem onClick={() => changeLanguage('french')} disabled={language === 'french'}>
                                            {/* <img src={require('../../assets/images/egypt.svg').default} alt="" /> */}
                                             <img src={require('../../assets/images/french.svg').default} alt="" />
                                            </DropdownItem>
                                        <DropdownItem onClick={() => changeLanguage('Portuguese')} disabled={language === 'Portuguese'}>
                                            <img src={require('../../assets/images/portuguese.svg').default} alt="" /></DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </NavItem>
                        </Nav>
                    </div>
                </div>
            </nav>
            <Modal isOpen={isedit} toggle={toggleEdit} centered>
                <div className="modal-header">
                    <h6 className="modal-title fs-10">{t('Upload Profile Image')}</h6>
                    <button type="button" className="btn-close" onClick={toggleEdit} aria-label="Close">
                        <X />
                    </button>
                </div>
                <ModalBody>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="col-sm-9">
                            <div className="d-flex justify-content-center">
                                <Avatar {...stringAvatar('USER')}
                                    src={profileImg && (profileImg instanceof File || profileImg instanceof Blob) ? URL?.createObjectURL(profileImg) : getProfile?.data?.image}
                                    sx={{ width: 150, height: 150 }}
                                />
                            </div>
                            <div className="mt-2">
                                <input
                                    name='profile' className="form-control"
                                    accept='.jpg,.png,.jpeg'
                                    type="file" id="formFileMultiple2"
                                    onChange={async (e) => {
                                        try {
                                            let img = e.target.files[0]
                                            const reader = new FileReader();
                                            clearErrors("profile")
                                            setValue("profile", null)
                                            setProfileImg(null)
                                            reader.onload = (event) => {
                                                const bytes = new Uint8Array(event.target.result);
                                                if ((bytes[0] === 0x89 && bytes[1] === 0x50) || (bytes[0] === 0xFF && bytes[1] === 0xD8)) { // png, apng, jpg, jpeg
                                                    handleProfileImg(e)
                                                } else {
                                                    setError("profile", { message: t('Please select image file') })
                                                }
                                            };
                                            reader.onerror = (error) => {
                                            };
                                            reader.readAsArrayBuffer(img);
                                        } catch (e) { }
                                    }} />
                                {errors.profile && <p className='errMsg'>{errors.profile.message}</p>}
                            </div>

                            <div>
                                <button className="btn btn-primary"
                                    disabled={updateProfileImage.isLoading}
                                >
                                    {updateProfileImage.isLoading ?
                                        <CircularProgress style={{ color: "#fff" }} size={20} /> :
                                        t("Update Profile")}
                                </button>
                            </div>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </header>
    );

}

export default InnerHeader;